import { useTranslation } from "react-i18next";
import { LocaleLink as Link } from "../i18n/LocaleLink";
import PageShell from "../components/layout/PageShell";
import AndroidInstallLink from "../components/ui/AndroidInstallLink";
import { usePageMeta } from "../lib/usePageMeta";

export default function AndroidApp() {
  const { t: translate } = useTranslation();
  const t = (key: string) => translate(`ui.web.android.${key}`, { lng: "en" });
  usePageMeta({ title: t("meta_title"), description: t("meta_description"), canonicalPath: "/android" });
  return <PageShell className="page-shell">
    <article lang="en" dir="ltr" className="page-inner max-w-4xl mx-auto px-5 py-8 sm:py-14">
      <section className="panel p-6 sm:p-10">
        <p className="font-mono text-xs text-brass-300">{t("eyebrow")}</p>
        <h1 className="font-display text-4xl sm:text-6xl text-parchment-50 leading-tight mt-4">{t("heading")}</h1>
        <p className="font-body text-lg text-parchment-200 leading-relaxed mt-5 max-w-2xl">{t("intro")}</p>
        <div className="flex flex-wrap items-center gap-4 mt-6">
          <AndroidInstallLink placement="android_hero" />
          <Link to="/sample-reading" className="text-brass-200 underline underline-offset-4 py-3">{t("web_demo")}</Link>
        </div>
        <p className="text-sm text-parchment-300 mt-4">{t("availability")}</p>
      </section>
      <div className="grid sm:grid-cols-3 gap-4 mt-6">
        {["chart", "period", "music"].map(feature => <section key={feature} className="panel p-6">
          <h2 className="font-display text-2xl text-brass-200">{t(`${feature}_title`)}</h2>
          <p className="text-parchment-200 mt-3 leading-relaxed">{t(`${feature}_body`)}</p>
        </section>)}
      </div>
      {["start", "method", "privacy"].map(section => <section key={section} className="mt-8">
        <h2 className="font-display text-2xl text-brass-200">{t(`${section}_title`)}</h2>
        <p className="text-parchment-200 mt-3 leading-relaxed">{t(`${section}_body`)}</p>
      </section>)}
      <a href="https://pmaero-byte.github.io/astrogenesis-support/privacy.html" className="inline-block text-brass-200 underline mt-4">{t("privacy_link")}</a>
      <div className="mt-8"><AndroidInstallLink placement="android_footer" /></div>
      <p className="text-sm text-parchment-400 mt-6">{t("english_notice")}</p>
    </article>
  </PageShell>;
}
